import * as React from 'react';
const AnchorCore = (props) => {
    const { external = false, } = props;
    const BEM = () => {
        const classArray = ['anchor'];
        if (props.color) {
            classArray.push('anchor--' + props.color);
        }
        if (props.isTextColor) {
            classArray.push('is-text-color');
        }
        if (props.isUnderlined) {
            classArray.push('is-underlined');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const handleClick = (event) => {
        if (!external && props.onClick) {
            props.onClick(event);
        }
    };
    return (React.createElement("a", Object.assign({}, props.attributes, { href: props.url, className: BEM(), onClick: handleClick, id: props.id, target: props.target, ref: props.elementRef, "aria-label": props['aria-label'], "aria-controls": props['aria-controls'], "aria-selected": props['aria-selected'], tabIndex: props.tabIndex, role: props.role }), props.children));
};
export default AnchorCore;
